import { getText } from "shared/lib";

import { ExternalLinkIcon } from "shared/components";

export function Fallback() {
  const renderRequestCertificateOfTitle = () => {
    return (
      <div>
        <h3 className="text-headingmd">
          {getText("Request a Certificate of Title")}
        </h3>
        <p className="text-bodymd mb-2">
          {getText(
            "This tool doesn't account for covenants (restrictions), caveats and easements, which can impact what you can and can't do on a property. A Certificate of Title can include this information, which you can request online.",
          )}
        </p>
        <a
          className="text-textLink hover:text-textLinkHover text-bodymd inline-flex cursor-pointer underline"
          href="https://www.landata.online/"
          rel="noreferrer"
          tabIndex={0}
          target="_blank"
        >
          {getText("Request a Certificate of Title")}
          <ExternalLinkIcon className="ml-2 mt-[3px]" />
        </a>
      </div>
    );
  };

  return renderRequestCertificateOfTitle();
}
